import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import {
  CellClassParams,
  ColDef,
  FilterChangedEvent,
  GridApi,
  GridOptions,
  RowClickedEvent,
} from 'ag-grid-community';
import { MasterActionRendererComponent } from 'src/app/core/grid-renderer/master-action-renderer/master-action-renderer.component';
import { MasterSettingsService } from 'src/app/services/master-settings.service';
import { UpdateMasterSettingsComponent } from 'src/app/core/check/update-master-settings/update-master-settings.component';
import { RefreshMasterSettingsComponent } from 'src/app/core/check/refresh-master-settings/refresh-master-settings.component';
import { Constants } from 'src/app/constants';
import { Router } from '@angular/router';
import { AetStateService } from 'src/app/services/aet-state.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-dashboard-master-config',
    templateUrl: './master-config.component.html',
    styleUrls: ['./master-config.component.scss'],
    standalone: false // NOSONAR
})
export class MasterConfigComponent implements OnInit {
  domicileList: any[] = [];
  step: any;
  gridApi: any;
  rowHeight = 30;
  defaultColDef: {};
  columnDefs: any[] = [];
  paginationPageSize: any = 10;
  icons: {};
  rowClassRules: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  displayRowData: any[] = [];
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  rowCount: number = 0;
  errorMessage: string;
  successMessage: string;
  preferenceData: any;
  searchParameters: FormGroup;
  problemTypes: any[];
  eventTypes: any[];
  eventProblemMapping: any[];
  autoGroupColDef: any;
  existingEvents: any[];
  settingsGroupTemplate: { [key: string]: any } = {};
  problemEventMap: { [key: string]: string } = {};
  defaultValues: { [key: string]: any };
  absoluteDefaultValues: { [key: string]: any };
  isAccessible=true;

  context: any;
  constructor(
      private readonly dialog : MatDialog,
     private readonly service : MasterSettingsService,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
     private readonly aetStateService : AetStateService,
     private readonly router : Router,
    private  readonly constants: Constants,
  ) {
    this.context = {
      componentParent: this,
    };
    this.defaultColDef = {
      suppressMovable: true,
      wrapHeaderText: true,
      suppressPaginationPanel: true,
      autoHeight: true,
      filter: true,
      floatingFilter: true,
    };
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',    // NOSONAR
    };
  }

  ngOnInit(): void {
    // this.checkRoles();
    this.onLoadMasterConfig();
  }
  onLoadMasterConfig(){
    this.service.loadMasterConfig().subscribe((response: any) => {
      this.domicileList = [];
      response.domiciles.forEach((element) => {
        if (!element.itemCode.includes('PDC')) {
          this.domicileList.push(element.itemCode);
        }
      });
      this.fetchSettings();
    });
  }

  // ngAfterViewInit() {
  //   let f = localStorage.getItem('footerheight');
  //   let h = localStorage.getItem('headerHeight');
  //   let t = localStorage.getItem('toolbarheight');
  //   console.info(f, h, t);
  //   let windowh = window.innerHeight;
  //   let headerfilter = document.getElementById('headerfilter')?.offsetHeight;
  //   let footerfilter = document.getElementById('footerfilter')?.offsetHeight;
  //   console.info(headerfilter, "headerfilter")
  //   const grid = document.getElementById('LIOS-grid');
  //   if (grid !=   null && headerfilter !=   null && footerfilter !=   null) {
  //     let gridHeight = (headerfilter + footerfilter +Number(f) + Number(h) + Number(t));
  //     grid.style.height = 'calc(100vh - ' + (gridHeight) + 'px)';
  //     grid.style.maxHeight = 'calc(100vh - ' + (gridHeight) + 'px)';
  //   }
  // }

  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON?.parse(roles);
  //   if(userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || 
  //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
  //   userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner) ){
  //     this.isAccessible = true;
  //   }
  //   else{
  //     this.router.navigate([`/home`]);
  //   }
  //   // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
  //   //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
  //   //   // this.isAccessible = true;
  //   // } else {
  //   //   this.router.navigate([`/home`]);
  //   // }
  // }
 
  fetchSettings() {
    this.context = {
      componentParent: this,
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.service.loadMasterSettingsOfDomicile().subscribe(
      (response: any) => {
        this.displayRowData = [];
        this.ngxUiLoaderService.stop(CommonConstant.loader);

        this.displayRowData = this.settingsDataMap(response);
        this.gridApi.applyTransaction({ add: this.displayRowData }); 
        this.rowCount = this.displayRowData.length;
        this.gridApi?.redrawRows();
        this.getColDefs();
      },
      (_error) => {
        this.displayRowData = [];
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = 'Something Went Wrong.Please Try Again!';
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      }
    );
  }

  getColDefs() {
    this.columnDefs = [
      {
        headerName: 'DOMICILE',
        field: 'domicile',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: true,
        filter: 'agTextColumnFilter',
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'UPDATE TRIGGER',
        field: 'updateTrigger',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        filter: false,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'RED TRIGGER',
        field: 'redTrigger',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        filter: false,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'YELLOW TRIGGER',
        field: 'yellowTrigger',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        filter: false,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'SNOOZE DELAY',
        field: 'snoozeDelay',
        floatingFilterComponentParams: { suppressFilterButton: true },
        floatingFilter: false,
        filter: false,
        sortable: true,
        unSortIcon: true,
      },
      {
        headerName: 'ACTION',
        field: 'action',
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellRenderer: MasterActionRendererComponent,
        floatingFilter: false,
        filter: false,
      },
    ];
  }
  onModelUpdated(): void {
    this.sizeToFit();
  }
  sizeToFit() {
    this.gridApi?.sizeColumnsToFit();
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.showLoadingOverlay();
  }

  settingsDataMap(response: any) {
    const result = [];
    const defaultValue = response.find((value) => 'DEFAULT' == value.domicile);  // NOSONAR
    this.domicileList.forEach((val) => {
      const resultStore = response.find((value) => val == value.domicile);  // NOSONAR
      if (resultStore) {
        result.push({
          domicile: val,
          redTrigger: resultStore.redTrigger,
          yellowTrigger: resultStore.yellowTrigger,
          snoozeDelay: resultStore.snoozeDelay,
          updateTrigger: resultStore.updateTrigger,
          updated: true,
        });
      } else {
        result.push({
          domicile: val,
          redTrigger: defaultValue.redTrigger,
          yellowTrigger: defaultValue.yellowTrigger,
          snoozeDelay: defaultValue.snoozeDelay,
          updateTrigger: defaultValue.updateTrigger,
          updated: false,
        });
      }
    });
    return result;
  }

  buttonActionUpdate(body) {
    const dialogRef = this.dialog.open(UpdateMasterSettingsComponent, {
      disableClose: true,
      width: '820px',
      height: '281px',
      data: {
        header: 'Update Master Settings',
        params: body,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      if (result?.event == 'objectUpdated') {   // NOSONAR
        if (result?.eventType == 'success') { // NOSONAR
          this.successMessage = 'Master Settings Updated Successfully';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
            this.onLoadMasterConfig();
          }, 2000);
        } else {
          this.errorMessage = 'Updating Master Settings Failed';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 2000);
        }
      }
    });
  }
 
  buttonActionRefresh(body) {
    const dialogRef = this.dialog.open(RefreshMasterSettingsComponent, {
      disableClose: true,
      width: '820px',
      height: '145px',
      data: {
        header: 'Confirm Reset Master Settings',
        type: 'reset',
        params: body,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      if (result?.event == 'objectUpdated') {  // NOSONAR
        if (result?.eventType == 'success') {  // NOSONAR
          this.successMessage =  'Master Settings Reset to Default Successfull';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
            this.onLoadMasterConfig();
          }, 2000);
          
        } else {
          this.errorMessage =  'Resetting Master Settings Failed';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 2000);
        }
      }
    });
  }
  buttonActionDelete(body) {
    const dialogRef = this.dialog.open(RefreshMasterSettingsComponent, {
      disableClose: true,
      width: '820px',
      height: '145px',
      data: {
        header: 'Confirm Disable Master Settings',
        type: 'delete',
        params:body,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      if (result?.event == 'objectUpdated') {  // NOSONAR
        if (result?.eventType == 'success') {  // NOSONAR
          this.successMessage =  'Master Settings Disabled Successfully';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
            this.onLoadMasterConfig();
          }, 2000);
          
        } else {
          this.errorMessage =  'Disabling Master Settings Failed';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 2000);
        }
      }
    });
  }
  onFilterChanged(params: FilterChangedEvent): void {
    this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
    this.rowCount = params.api?.getDisplayedRowCount();
    const check = document.getElementById('lbTotalPages').innerHTML;
    if (this.rowCount == 0 && Number(check) == 0) {  // NOSONAR
      document.getElementById('lbCurrentPage').innerHTML = '0';
    }
  }
  goToNexpage() {
    this.gridApi.paginationGoToNextPage();
  }
  goToPreviousPage() {
    return this.gridApi.paginationGoToPreviousPage();
  }
  goToFirstPage() {
    this.gridApi.paginationGoToFirstPage();
  }
  goToLastPage() {
    return this.gridApi.paginationGoToLastPage() ;
  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    } else {
      this.currentPageBoolean = false;
    }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage =
      Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    } else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  onPaginationChanged() {
    if (this.gridApi) {
      this.setText(
        '#lbCurrentPage',
        this.gridApi.paginationGetCurrentPage() + 1
      );
      this.setText('#lbTotalPages', this.gridApi.paginationGetTotalPages());
      this.setLastButtonDisabled(!this.gridApi.paginationIsLastPageFound());
    }
  }
  setText(selector: string, text: any) {
    if (this.rowCount > 0) {
      (document.querySelector(selector) as any).innerHTML = text;
    }
    // else {
    //   (document.querySelector(selector) as any).innerHTML = 0;
    // }
  }
  setLastButtonDisabled(_disabled: boolean) {
    this.isLastPageFound = true;
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == 'ALL') {  // NOSONAR
      this.paginationPageSize = event.target.value;
    } else {
      this.paginationPageSize = event.target.value;
      this.gridApi?.paginationSetPageSize(Number(event.target.value));
    }
  }
  close(){
    this.successMessage=null;
    this.errorMessage=null;
  }
}
